// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7ViOW","placeholdersHeader":"styles_placeholdersHeader__1ijDf","editorStyle":"styles_editorStyle__1chAF","placeholdersBox":"styles_placeholdersBox__3RsNW"};